import React,{useState} from "react";
import Modal from "react-responsive-modal";
import { useGlobalContext } from "../Context/GlobalContext";

export default function DeleteModal({setClose,open, setOpen,callback,isLoading,setIsLoading}) {
  const {baseUrl,openToast}=useGlobalContext();
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  async function callDeleteMethod(){
    callback()
    onCloseModal()
  }

  return (
    <div className="inset-0 flex justify-center items-center bg-opacity-50">
      <Modal open={open} onClose={onCloseModal}>
      <div className="bg-white p-6 rounded-lg w-full max-w-lg h-[200px]">
        <h2 className="mt-[28px] mb-[28px] font-semibold text-[18px] text-[black] text-center text-xl">
          Are you sure want to Delete this ?{" "}
        </h2>
        <div className="flex justify-around">
          <button
            disabled={isLoading ?? false}
            onClick={callDeleteMethod}
            className={`px-4 py-2 bg-[#27004a] text-[14px] text-white rounded-md ${
              isLoading ? "opacity-50" : ""
            }`}
          >
          
            {isLoading ? "Confirming..." : " Yes , Confirm"}
          </button>
          <button
            onClick={setClose}
            className="bg-[#27004a] px-4 py-2 rounded-md text-[14px] text-white"
          >
            No , Cancel
          </button>
        </div>
      </div>
      </Modal>
    </div>
  );
}
